<template>
    <div>
        <div v-if="status == 0">
            Mengambil data barang, mohon menunggu...
        </div>
        <div v-else-if="status == -1">
            Gagal mengambil data barang.
        </div>
        <div v-else-if="status == 1">
            <h3 id="item-type" class="mb-0">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></h3>
            <span id="item-kind">{{ data.kind }}</span> - <span id="item-brand">{{ data.brand }}</span>

            <b-badge id="photo-status" v-if="!data.is_valid_photo" variant="danger">Foto tidak lengkap</b-badge>
            <div>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>No. Faktur</strong><br />
                        <span id="no-faktur">{{ data.no_faktur_pgi }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>IMEI / SN</strong><br />
                        <span id="imei-sn">{{ data.imei_sn }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Grade</strong><br />
                        <span id="grade">{{ data.grade }}</span>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <strong>Kelengkapan</strong><br />
                        <span id="kelengkapan">{{ kelengkapan }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Spek</strong><br />
                        <span id="spek">{{ data.spec }}</span>
                    </b-col>
                    <b-col md="4">
                        <strong>Harga Dasar</strong><br />
                        <span id="harga-dasar">{{ getDisplayPrice(data.price) }}</span>
                    </b-col>
                </b-row>
            </div>
            <b-table id="adjustment-table" bordered hover show-empty no-local-sorting :items="items" :fields="filteredFields" responsive class="my-4"
                @sort-changed="onSortChanged">
                <template v-slot:empty>
                    Tidak ada adjustment.
                </template>
                <template v-slot:cell(category)="row">
                    <div>
                        {{ row.item.category_name }}
                    </div>

                    <b-badge id="photo-status-badge" v-if="!row.item.is_adjustments_photo" variant="danger">Foto tidak tersedia</b-badge>
                </template>
                <template v-slot:cell(name)="row">
                    <div>
                        {{ row.item.adjustments_name }}
                    </div>
                </template>
                <template v-slot:cell(adjustment)="row">
                    <b-input-group id="adjustment-input-group" :prepend="checkAdjustment(row.item).prepend">
                        <b-form-input
                            :value="
                                    String(row.item.adjustment).replace('-', '')
                                "
                            :class="checkAdjustment(row.item).class"
                            id="adjustment-input"
                            @input="onAdjustmentInput(row.item)"
                            disabled
                        />
                    </b-input-group>
                </template>
                <template v-slot:cell(adjustmentPercent)="row">
                    <b-input-group id="adjustment-percent-input-group" append="%">
                        <b-form-input
                            id="adjustment-percent-input"
                            v-model="row.item.adjustmentPercent"
                            @input="onAdjustmentPercentInput(row.item)"
                            disabled
                        />
                    </b-input-group>
                </template>
                <template v-slot:cell(action)="row">
                    <div id="action-buttons" class="d-flex">
                        <b-button id="image-button" size="sm" variant="dark" v-b-tooltip.hover.top title="Gambar Kerusakan"
                            :disabled="isSubmitting" @click="prepareAdjImage(row.item)">
                            <i class="fa fa-fw fa-picture-o" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="dark" v-b-tooltip.hover.top title="Edit Harga"
                            :disabled="isSubmitting || !hasEditAdjPricePermission" @click="editAdjustment(row.item)">
                            <i class="fa fa-fw fa-pencil" />
                            </b-button>
                        <b-button
                        id="delete-button" size="sm" variant="danger" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                            :disabled="isSubmitting || !hasDeleteAdjInventoryPermission" @click="deleteRow(row.item)">
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </div>
                </template>
            </b-table>

            <b-row>
                <b-col md="8" v-if="invoiceDetailId">
                    <b-button v-if="hasAddAdjInventoryPermission" class="mr-2" id="add-adjustment-button" variant="dark" @click="prepareAddAdjustment" :disabled="isSubmitting">
                        <i class="fa fa-plus mr-2" />Tambah Keterangan
                    </b-button>
                    <!-- <b-button v-if="isShowSimulationAdjDamage" :disabled="isSubmitCalculate || this.items.length == 0" id="calculate-button" variant="dark" @click="calculatedAdjustment">
                        <i class="fa fa-calculator mr-2"/>
                            Simulasi Adjustment Kerusakan
                    </b-button> -->
                </b-col>
                <b-col md="12" v-if="!invoiceDetailId" class="text-right">
                    <b-button id="confirm-add-button" variant="primary" @click="confirmAdd" :disabled="isSubmitting">
                        <i class="fa fa-check mr-2" />Lanjutkan
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <b-modal id="m-confirm" size="lg" title="Konfirmasi" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div id="confirmation-text">Konfirmasi {{ invoiceDetailId == null ? 'penambahan' : 'pengubahan' }} barang ini kedalam invoice.</div>
            <b-row class="mt-4">
            <b-col md="6">
                <strong id="confirm-no-faktur-label">No. Faktur</strong><br />
                <span id="confirm-no-faktur">{{ data.no_faktur_pgi }}</span>
            </b-col>
            <b-col md="6">
                <strong id="confirm-harga-dasar-label">Harga Dasar</strong><br />
                <span id="confirm-harga-dasar">Rp. {{ $helper.formatThousand(data.price) }}</span>
            </b-col>
            </b-row>
            <b-row class="mt-3">
            <b-col md="6">
                <strong id="confirm-barang-label">Barang</strong><br />
                <span id="confirm-barang">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></span>
            </b-col>
            <b-col md="6">
                <strong id="confirm-total-adjustment-label">Total Pot / Tambahan Harga</strong><br />
                <p id="confirm-total-adjustment-percent" class="mb-0" v-if="!$helper.isBlank(totalAdjustmentPercent)">
                {{ Number(totalAdjustmentPercent).toFixed(2) + "% (Rp. " + $helper.formatThousand(totalAdjustmentPercentValue) + ")" }}</p>
                <p id="confirm-total-adjustment" class="mb-0" v-if="!$helper.isBlank(totalAdjustment) || $helper.isBlank(totalAdjustmentPercent)">
                Rp. {{ $helper.formatThousand(totalAdjustment) }}</p>
            </b-col>
            </b-row>
            <b-row class="mt-3">
            <b-col md="6">
                <strong id="confirm-imei-sn-label">IMEI / SN</strong><br />
                <span id="confirm-imei-sn">{{ data.imei_sn }}</span>
            </b-col>
            <b-col md="6">
                <strong id="confirm-adjustment-price-segment-label">Tambahan Harga Jual Online</strong><br />
                <span id="confirm-adjustment-price-segment">Rp. {{ $helper.formatThousand(data.adjustment_price_segment) }}</span>
            </b-col>
            </b-row>
            <b-row class="mt-3">
            <b-col md="6">
                <strong id="confirm-note-label">Catatan Barang</strong><br />
                <span id="confirm-note">{{ note || "-- Tidak ada catatan --" }}</span>
            </b-col>
            <b-col md="6">
                <strong id="confirm-harga-akhir-label">Harga Akhir</strong><br />
                <strong id="confirm-harga-akhir">Rp. {{ $helper.formatThousand(data.price + totalAdjustment + totalAdjustmentPercentValue + data.adjustment_price_segment) }}</strong>
            </b-col>
            </b-row>
            <div class="mt-4 text-right">
            <b-button id="confirm-add-button" v-if="invoiceDetailId == null" variant="primary" :disabled="isSubmitting" @click="execAddItem">
                {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
            </b-button>
            <b-button id="confirm-edit-button" v-else variant="primary" :disabled="isSubmitting" @click="execEditItem">
                {{ isSubmitting ? "Mengubah..." : "Ubah" }}
            </b-button>
            </div>
        </b-modal>

        <b-modal id="m-image" :title="'Edit Gambar Kerusakan Item ' + data.type + ' (' + activeAdjustment.adjustments_name + ')'"
            size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
            <b-col cols="12" lg="8">
                <div id="media-container" class="media-container">
                <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                    :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                    blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                    :key="mediaPreview.url">
                    <source v-if="mediaPreview.type == 'video/webm'"
                    :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                    :type="mediaPreview.type">
                    <source v-else-if="mediaPreview.type == 'video/ogg'"
                    :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                    :type="mediaPreview.type">
                    <source v-else-if="mediaPreview.type == 'video/mp4'"
                    :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                    :type="mediaPreview.type">
                    <source v-else-if="mediaPreview.type == 'video/3gpp'"
                    :src="mediaPreview.status == 'upload' ? mediaPreview.url : mediaPreview.url"
                    :type="mediaPreview.type">
                    Your browser does not support the video tag.
                </video>
                <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                    alt="No Image"></b-img-lazy>
                </div>
                <div id="media-scroll" class="media-scroll">
                <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                    @click="onClickImage(media.url)">
                    <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                    :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : media.url"
                    blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                </div>
                </div>
            </b-col>
            <b-col cols="12" lg="4" class="border-responsive">
                    <!-- <b-button block variant="success" :disabled="filterMediaList.length >= 10 || isSubmitting"
                        @click="onAddImage">
                        {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                    </b-button> -->

                <b-button id="refresh-button" block variant="warning" class="mb-2" @click="onRefreshImage()">
                    Refresh
                </b-button>

                <span id="uploadFile" class="my-2">
                <b-button
                    @click="triggerFileInputForAdjustment"
                    :disabled="!hasAddPhotoAdjPermission"
                    id="upload-button" block variant="success">
                    {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                </b-button>
                <input
                    type="file"
                    ref="fileInputAdjustment"
                    style="display: none;"
                    accept="image/jpeg, image/png, video/mp4, video/quicktime"
                    @change="uploadFileForAdjustment"
                    multiple
                />
                </span>

                <b-button id="open-image-button" block variant="primary" class="mt-2"
                :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                @click="onOpenImage(mediaPreview.url)">
                {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                </b-button>
                <b-button id="delete-image-button" block variant="danger"
                :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting || !hasDeletePhotoAdjPermission"
                @click="onDeleteImage(mediaPreview.url)">
                {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                </b-button>
                <div id="media-disclaimer" class="mt-3 media-disclaimer">
                <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                    PNG.</small><br>
                <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan
                    WEBM.</small><br>
                <small>*Maksimal ukuran total gambar / video untuk sekali upload sebesar 200MB.</small><br>
                <small>*Minimal jumlah item gambar / video per inventori sebanyak 1 buah item.</small><br>
                <small>*Maksimal jumlah item gambar / video per inventori sebanyak 10 buah item.</small>
                </div>
            </b-col>
            </b-row>
             <input id="file-upload-input" multiple style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file"
            @change="onUploadImage" accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg">

            <loading-overlay
                :fotoStartTime="uploadTimeStamp.startPresignedUrl"
                :fotoEndTime="uploadTimeStamp.endPresignedUrl"
                :uploadStartTime="uploadTimeStamp.startUploadToS3"
                :uploadEndTime="uploadTimeStamp.endUploadToS3"
                :penyimpananStartTime="uploadTimeStamp.startSaveFile"
                :penyimpananEndTime="uploadTimeStamp.endSaveFile"
                :show="isShowLoadingOverlay"
            />
        </b-modal>

        <b-modal id="m-add-adjustment" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group id="jenis-barang-group" label="Jenis Barang">
            <b-form-select id="jenis-barang-select" v-model="addAdj.kind" :options="addAdj.optKind" disabled />
            </b-form-group>
            <b-form-group id="kategori-kerusakan-group" label="Kategori Kerusakan">
            <b-form-select id="kategori-kerusakan-select" v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group id="keterangan-group" label="Keterangan">
            <b-form-select
                id="keterangan-select"
                v-model="addAdj.name"
                :options="addAdj.optAdjustments"
                :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0"
                @change="onSelectAdjustment"
            />
            </b-form-group>
            <b-form-group id="adjustment-harga-nominal-group" label="Adjustment Harga (Nominal)">
            <b-input-group id="adjustment-harga-nominal-input-group" :prepend="`Rp. ${addAdj.is_increment == 0 ? '-' : ''}`">
                <b-form-input id="adjustment-harga-nominal-input" v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                :disabled="$helper.isBlank(addAdj.name) || addAdj.adjustmentPercentage != '' || addAdj.hasAdjustmentPrice" maxlength="50" />
            </b-input-group>
            </b-form-group>
            <div id="add-adjustment-buttons" class="mt-4 text-right">
            <b-button id="confirm-add-adjustment-button" variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                {{ isSubmitting ? "Menambah..." : "Tambah" }}
            </b-button>
            </div>
        </b-modal>

        <b-modal id="m-edit-adjustment" title="Edit Harga Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group :prepend="`Rp. ${editAdj.is_increment == 0 ? '-' : ''}`">
                    <b-form-input v-model="editAdj.adjustment" @input="sanitize(editAdj)"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEditAdjustment">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-sync-adjustment-confirm" title="Konfirmasi Update Harga Adjustment" centered hide-footer>
            <div>
                Apakah Anda yakin ingin mengupdate harga adjustment dengan data rumus?
            </div>
                <div class="mt-4 text-right">
                    <b-button variant="secondary" @click="$bvModal.hide('m-sync-adjustment-confirm')" :disabled="isSubmitting">
                        Batal
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="syncAdjustmentPrice" :disabled="isSubmitting">
                        {{ isSubmitting ? "Memproses..." : "Ya, Update" }}
                    </b-button>
                </div>
        </b-modal>
    </div>
</template>

<script>
import lodash from 'lodash'
import Uploading from './Uploading.vue'
import LoadingOverlay from './LoadingOverlay.vue'
import EnumPermissions from '@/shared/enum-permissions';

export default {
    props: {
        noFaktur: { type: String, required: true },
        invoiceId: { type: Number, required: true },
        invoiceDetailId: { type: Number, default: null }
    },
    components: {
        Uploading,
        LoadingOverlay
    },
    data() {
        return {

            status: 0, // 0: loading, 1: success, -1: fail
            isSubmitting: false,

            data: {},
            totalAdjustment: 0,
            totalAdjustmentPercent: 0,
            totalAdjustmentPercentValue: 0,
            note: "",
            photo: null,

            fields: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],

            sortBy: null,
            sortDesc: false,

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            invoiceAdjustments: [],

            optCategory: [],

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                adjustmentPercentage: "",
                hasAdjustmentPrice: false,
                selectedCategoryAdjustments: [],
                is_increment: null,
            },
            editAdj: {
                adjustment_id: null,
                adjustment: "",
                pendingSyncAdjustmentId: null,
                is_increment: null,
            },

            activeAdjustment: {},

            activeAdjustmentRow : null,
            finalizeBroken: false,
            goldPrice: null,
            adjustmentPercentages: [],
            totalAdjustmentPrice: 0,
            fieldAdjustmentPercentages: [
                { key: "adjustment_descrtiption", label: "Kategori & Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment_price", label: "Potongan / Tambahan Harga", sortable: false },
            ],
            isSubmitCalculate: false,
            isShowLoadingOverlay: false,
            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null,
            },

        }
    },
    methods: {

        init() {

            this.status = 0

            this.getItems()

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let payload = {
                no_faktur_pgi: this.noFaktur,
                invoice_id: this.invoiceId
            }

            if (this.invoiceDetailId != null) {
                payload.invoice_detail_id = this.invoiceDetailId
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                payload["sortBy"] = this.sortBy
                payload["sortDesc"] = this.sortDesc
            }
            this.$axios.post("invoice/get-item", payload).then(res => {

                let data = res.data.data
                this.data = data

                this.items = data.adjustments

                if (this.invoiceDetailId != null) {
                    this.note = data.note
                }


                this.$axios.get("category/selection?item_kind_id=" + data.kind_id).then(res => {
                    this.optCategory = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })

                    // diubah sementara supaya adjustment harga bisa diinput manual dulu
                    // this.items.forEach(it => {
                    //     it.adjustmentSelect = {
                    //         adjustments_id: it.adjustments_id,
                    //         adjustments_name: it.adjustments_name,
                    //         adjustment: it.adjustment,
                    //         adjustment_percentage: it.adjustment_percentage
                    //     }
                    // })

                    this.status = 1

                })
                    .catch(error => {

                        this.$helper.parseError(this, error)
                        this.status = -1

                    })

            })
                .catch(error => {

                    this.$helper.parseError(this, error)
                    this.status = -1

                })
        },


        checkAdjustment(item) {
            let val = Number(String(item.adjustment).replace(/\./g, ""));
            let result = {
                class: "",
                prepend: "Rp. "
            };

            if (val == 0) {
                result.class = "text-black";
            } else if (val < 0) {
                result.class = "text-danger";
                result.prepend = "Rp. -";
            } else if (val > 0) {
                result.class = "text-success";
            }
            return result;
        },

        // addRow() {
        //     this.items.push({ name: "", adjustmentSelect: "", adjustment: "", adjustmentPercent: "" })
        // },

        deleteRow(item) {
            const isConfirmed = confirm("Apakah Anda yakin ingin menghapus data adjustment ini?");
            if (!isConfirmed) return;

            const payload = {
                invoice_detail_id: this.invoiceDetailId,
                inventory_id: item.inventory_id,
                adjustment_id: item.adjustments_id
            }

            this.isSubmitting = true
            this.$axios.delete("invoice/delete-invoice-adjustment", { data: payload }).then(() => {
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Dihapus!")
                this.getItems();
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        editAdjustment(item) {
            if (item.has_adj_formula) {
                this.editAdj.pendingSyncAdjustmentId = item.adjustments_id;
                this.$bvModal.show('m-sync-adjustment-confirm');
                return
            }
            this.editAdj.adjustment_id = item.adjustments_id
            this.editAdj.adjustment = ""
            this.editAdj.is_increment = item.is_increment;
            this.$bvModal.show("m-edit-adjustment")
        },

        syncAdjustmentPrice() {
            const payload = {
                invoice_detail_id: this.invoiceDetailId,
                adjustment_id: this.editAdj.pendingSyncAdjustmentId
            }

            this.isSubmitting = true
            this.$axios.patch("invoice/sync-adjustment-price", payload).then(() => {
                this.$helper.toastSuccess(this, "Harga Adjustment Berhasil Diupdate!");
                this.getItems();
                this.$bvModal.hide('m-sync-adjustment-confirm');
                this.editAdj.pendingSyncAdjustmentId = null;
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },


        confirmEditAdjustment() {
            if (this.$helper.isBlank(this.editAdj.adjustment)) {
                this.$helper.toastError(this, "Data Adjustment Nominal tidak boleh kosong !")
                return
            }

            const payload = {
                invoice_detail_id: this.invoiceDetailId,
                adjustment_id: this.editAdj.adjustment_id,
                adjustment: this.$helper.toNumber(this.editAdj.is_increment == 0 ? '-' + this.editAdj.adjustment : this.editAdj.adjustment)
            }

            this.isSubmitting = true
            this.$axios.patch("invoice/edit-invoice-adjustment", payload).then(() => {
                this.getItems();
                this.$helper.toastSuccess(this, "Data Adjustment Berhasil Diubah!")
                this.$bvModal.hide("m-edit-adjustment")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        confirmAdd() {

            let adjustment = 0
            let adjustmentPercent = 0

            for (var i = 0; i < this.items.length; i++) {

                let item = this.items[i]

                if (!this.$helper.isBlank(item.adjustment)) {
                    if (typeof item.adjustment === 'string') {
                        adjustment += this.$helper.toNumber(item.adjustment)
                    }
                    else {
                        adjustment += item.adjustment
                    }
                }

            }

            if (this.data.price + adjustment < 0) {
                return this.$helper.toastError(this, "Tidak dapat menambahkan barang - harga akhir setelah adjustment dibawah nol!")
            }

            this.totalAdjustment = adjustment
            this.totalAdjustmentPercent = adjustmentPercent
            this.totalAdjustmentPercentValue = this.data.price * this.totalAdjustmentPercent / 100
            this.$bvModal.show("m-confirm")

        },

        execAddItem() {

            const createAdjustments = () =>
                this.items.map(it => {
                    const adjustmentPercent = it.adjustmentPercent
                        ? it.adjustmentPercent.replace(',', '.').replace(' ', '')
                        : null;

                    return {
                        id: it.adjustments_id,
                        name: it.adjustments_name,
                        adjustment: adjustmentPercent
                            ? parseInt(this.data.price * parseFloat(adjustmentPercent) / 100)
                            : typeof it.adjustment === 'string' ? this.$helper.toNumber(it.adjustment) : it.adjustment,
                        adjustmentPercent: adjustmentPercent
                            ? Number(parseFloat(adjustmentPercent)).toFixed(2)
                            : null,
                    };
                });

            const createPayload = () => {
                const payload = {
                    no_faktur_pgi: this.noFaktur,
                    invoice_id: this.invoiceId,
                    adjustments: createAdjustments(),
                };

                if (!this.$helper.isBlank(this.note)) {
                    payload.note = this.note;
                }

                return payload;
            };

            const payload = createPayload();

            const url = "invoice/add-item"

            this.isSubmitting = true;
            this.$axios
                .post(url, payload)
                .then(res => {
                    this.$bvModal.hide("m-confirm");
                    const info = (res.data && res.data.data && res.data.data.info)
                        ? res.data.data.info
                        : "Barang berhasil ditambahkan!";
                    this.$emit("item-added", info);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        execEditItem() {

            const createAdjustments = () =>
                this.items.map(it => {
                    const adjustmentPercent = it.adjustmentPercent
                        ? it.adjustmentPercent.replace(',', '.').replace(' ', '')
                        : null;
                    const isBlankPercent = this.$helper.isBlank(it.adjustmentPercent);

                    return {
                        id: it.adjustments_id,
                        name: it.adjustments_name,
                        adjustment: isBlankPercent
                            ? typeof it.adjustment === 'string' ? this.$helper.toNumber(it.adjustment) : it.adjustment
                            : parseInt(this.data.price * parseFloat(adjustmentPercent) / 100),
                        adjustmentPercent: isBlankPercent
                            ? null
                            : Number(parseFloat(adjustmentPercent)).toFixed(2),
                    };
                });

            const createPayload = () => {
                const payload = {
                    invoice_detail_id: this.invoiceDetailId,
                    adjustments: createAdjustments(),
                };

                if (!this.$helper.isBlank(this.note)) {
                    payload.note = this.note;
                }

                return payload;
            };

            const payload = createPayload();
            const url = "invoice/edit-item";

            this.isSubmitting = true;
            this.$axios
                .post(url, payload)
                .then(() => {
                    this.$bvModal.hide("m-confirm");
                    this.$emit("item-added", "Barang berhasil diubah!");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        sanitize(item) {

            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res

        },

        sanitizeString(str) {
            let cleaned = String(str).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return res
        },


        prepareAddAdjustment() {
            this.addAdj.optKind = [
                { value: this.data.kind_id, text: this.data.kind }
            ]
            this.addAdj.kind = this.data.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            this.addAdj.adjustment = ""
            this.addAdj.adjustmentPercentage = ""
            this.$bvModal.show("m-add-adjustment")
        },

        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(this, "Data Keterangan Adjustment Kerusakan tidak boleh kosong !")
                return
            }

            if (this.$helper.isBlank(this.addAdj.adjustment)) {
                this.$helper.toastError(this, "Data Adjustment Nominal tidak boleh kosong !")
                return
            }

            let payload = new FormData()

            payload.append("inventory_id", this.data.id)
            payload.append("adjustment_id", this.addAdj.name)
            if (this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                payload.append("adjustment", this.$helper.toNumber(this.addAdj.is_increment == 0 ? '-' + this.addAdj.adjustment : this.addAdj.adjustment))
            }
            else {
                payload.append("adjustment", parseInt(this.data.price * parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100))
                payload.append("adjustment_percentage", Number(parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2))
            }

            let url = ""

            if (this.$helper.isBlank(this.invoiceDetailId)) {
                url = "inventory/add-invoice-adjustments"
            }
            else {
                url = "invoice/add-invoice-adjustment"
                payload.append("invoice_detail_id", this.invoiceDetailId)
            }
            this.isSubmitting = true
            this.$axios.post(url, payload).then(res => {

                let payload = {
                    no_faktur_pgi: this.noFaktur,
                    invoice_id: this.invoiceId
                }

                if (this.invoiceDetailId != null) {
                    payload.invoice_detail_id = this.invoiceDetailId
                }

                if (!this.$helper.isBlank(this.sortBy)) {
                    payload["sortBy"] = this.sortBy
                    payload["sortDesc"] = this.sortDesc
                }
                this.$axios.post("invoice/get-item", payload).then(res => {

                    let data = res.data.data
                    this.data = data


                    this.items = data.adjustments

                    if (this.invoiceDetailId != null) {
                        this.note = data.note
                    }

                    this.$bvModal.hide("m-add-adjustment")
                    this.isSubmitting = false

                })

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },
        onChangeRowCategory(index) {
            this.items[index].name = ""
            this.items[index].adjustmentSelect = null
            this.items[index].optAdjustments = []
            if (!this.$helper.isBlank(this.items[index].category)) {
                let param = "?item_kind_id=" + this.data.kind_id
                param += "&category_id=" + this.items[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.items[index].optAdjustments = res.data.data.map(item => {
                        return {
                            value: {
                                adjustments_id: item.id,
                                adjustments_name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentage: item.adjustment_percentage,
                            },
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.data.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    this.addAdj.selectedCategoryAdjustments = res.data.data;
                    this.isSubmitting = false
                })
            }
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item
            this.mediaPreview = {}
            this.mediaList = []
            this.activeAdjustment = item
            this.isSubmitting = true
            let param = "?inventory_id=" + this.data.id
            param += "&adjustment_id=" + this.activeAdjustment.adjustments_id
            this.$axios.get("adjustment-damaged-photo" + param).then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let fileMedia = ''
                    let fileAltText = ''
                    if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                        fileMedia = 'image'
                        fileAltText = 'Upload Image Preview'
                    }
                    else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                        fileMedia = 'video'
                        fileAltText = 'Upload Video Preview'
                    }
                    else {
                        continue
                    }
                    let filenameSplit = res.data.data[i].path.split('/')
                    filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                    let fileExtension = filenameSplit.pop()
                    let filename = filenameSplit.join()
                    this.mediaList.push({
                        id: res.data.data[i].id,
                        media: fileMedia,
                        type: res.data.data[i].type,
                        filename: filename,
                        extension: fileExtension,
                        url: res.data.data[i].path,
                        altText: fileAltText,
                        status: 'get',
                        isActive: false,
                        file: null
                    })
                }
                this.isImageChanged = false
                this.$bvModal.show("m-image")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false
                if (this.mediaList[i].url == url) {
                    this.mediaList[i].isActive = true
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i])
                }
            }
        },

        onAddImage() {
            this.$refs.fileupload.click()
        },

        onUploadImage(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            // else if(files[0].size > this.$uploadLimit) {
            //     return
            // }
            if (this.filterMediaList.length + files.length > 10) {
                this.$helper.toastError(this, "Operasi Upload Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }
            for (let i = 0; i < files.length; i++) {
                let fileMedia = ''
                let fileAltText = ''
                if (files[i].type == 'image/jpeg' || files[i].type == 'image/png') {
                    fileMedia = 'image'
                    fileAltText = 'Upload Image Preview'
                }
                else if (files[i].type == 'video/mp4' || files[i].type == 'video/webm' || files[i].type == 'video/ogg') {
                    fileMedia = 'video'
                    fileAltText = 'Upload Video Preview'
                }
                else {
                    this.$helper.toastError(this, "Upload Item Gagal! Jenis file " + files[i].name + " tidak dikenali oleh sistem.")
                    continue
                }
                let filenameSplit = files[i].name.split('.')
                let fileExtension = filenameSplit.pop()
                let filename = filenameSplit.join()
                let fileResult = {
                    id: null,
                    media: fileMedia,
                    type: files[i].type,
                    filename: filename,
                    extension: fileExtension,
                    url: URL.createObjectURL(files[i]),
                    altText: fileAltText,
                    status: 'upload',
                    isActive: false,
                    file: files[i]
                }
                this.mediaList.push(fileResult)
                // for(let i = 0; i < this.mediaList.length; i++){
                //     this.mediaList[i].isActive = false
                // }
                // this.mediaPreview = lodash.cloneDeep(fileResult)
                this.isImageChanged = true
                this.$helper.toastSuccess(this, "Upload " + files[i].name + " berhasil!")
            }
            this.$refs.fileupload.value = null
        },

        onOpenImage(url) {
            window.open(url, '_blank')
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == 'get') {
                        this.mediaList[i].status = 'delete'

                        let payload = new FormData()

                        payload.append("inventory_id", this.data.id)
                        payload.append("id_photo", this.mediaList[i].id)

                        this.$axios.post("adjustment-damaged-photo/delete", payload).then(_ => {
                            this.$helper.toastSuccess(this, "Hapus Gambar Berhasil!")
                            // this.$bvModal.hide("m-image")
                            if (this.isChangePhotoAdjustment) {
                                this.isChangeAdjustment = true
                            }

                            this.getItems()

                        })
                            .catch(error => this.$helper.parseError(this, error))
                    }
                    else {
                        this.mediaList.splice(i, 1)
                    }
                    this.isImageChanged = true
                    break
                }
            }
            this.mediaPreview = {}
        },

        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow)
        },
        sanitizeCapital() {
            let cleaned = String(this.goldPrice).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.goldPrice = res
        },
        getDisplayPrice(price) {
            return `Rp. ${this.$helper.formatThousand(price)}`;
        },
        async calculatedAdjustment() {
            this.isSubmitCalculate = true;
            const payload = {
                inventory_id: this.data.id,
            }
            try {
                const response = await this.$axios.post('adjustment/calculate', payload)
                // Update the adjustments array with the price and percentage from the response
                if (response.data.success && response.data.data.adjustments) {
                    this.adjustmentPercentages = response.data.data.adjustments.map((adj) => {
                        return {
                            ...adj,
                            adjustment_price: this.formatCurrency(adj.adjustment_price),
                            current_adjustment_price: this.formatCurrency(adj.current_adjustment_price)
                        }
                    });
                    this.totalAdjustmentPrice = this.formatCurrency(response.data.data.total_adjustment_price);
                }

                this.$bvModal.show("m-calculate-adjustment");
                this.isSubmitCalculate = false;
            } catch (error) {
                this.$helper.parseError(this, error)
                this.isSubmitCalculate = false;
            }
        },
        onCloseModalCalculate() {
            this.$bvModal.hide("m-calculate-adjustment");
        },
        formatCurrency(value) {
            const stringValue = typeof value === 'number' ? value.toFixed(2) : value;
            let [integerPart, decimalPart = '00'] = stringValue.split('.');
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            decimalPart = decimalPart.padEnd(2, '0');

            return `${integerPart},${decimalPart}`;
        },
        triggerFileInputForAdjustment() {
            this.$refs.fileInputAdjustment.click();
        },
        async getPresignedUrl(fileName, fileType, directoryPath) {

            this.uploadTimeStamp.startPresignedUrl = this.formatTime(new Date());
            const response = await this.$axios.post('get-presigned-url', {
                file_name: fileName,
                file_type: fileType,
                reference_key: this.data.no_faktur_pgi,
                directory_path: directoryPath,
            });
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
            const response = await fetch(presignedUrl, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type,
                },
            });
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },
        async uploadFileForAdjustment(event) {
            const files = Array.from(event.target.files); // Convert FileList to an array
            if (!files || files.length === 0) return;

            // Validate file types and sizes
            const allowedImageTypes = ['image/jpeg', 'image/png'];
            const allowedVideoTypes = ['video/mp4', 'video/quicktime'];
            const maxSize = 400 * 1024 * 1024; // 400MB
            let totalSize = 0;

            for (const file of files) {
                if (!allowedImageTypes.includes(file.type) && !allowedVideoTypes.includes(file.type)) {
                    this.$helper.toastError(this, "Jenis file tidak valid. Silakan unggah gambar (JPG, PNG) atau video (MP4, MOV).");
                    return;
                }
                totalSize += file.size;
                if (totalSize > maxSize) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.");
                    return;
                }
            }

            // Show loading state
            this.isShowLoadingOverlay = true;

            try {
                const payload = new FormData();
                for (const file of files) {
                    // Fetch presigned URL from the backend
                    const { presigned_url, file_path } = await this.getPresignedUrl(file.name, file.type, "adjdmgpht");

                    // Upload file to S3 using the presigned URL
                    await this.uploadToS3(file, presigned_url);


                    // Append file metadata to the payload
                    payload.append("url[]", file_path);
                    payload.append("fileName[]", file_path);
                }

                // Add inventory and adjustment IDs to the payload
                payload.append("inventory_id", this.activeAdjustmentRow.inventory_id);
                payload.append("adjustment_id", this.activeAdjustmentRow.adjustments_id);
                payload.append("upload_provider", "aws");

                this.uploadTimeStamp.startSaveFile = this.formatTime(new Date());

                // Send the payload to the backend
                await this.$axios.post("adjustment-damaged-photo/update", payload);


                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());
                this.isShowLoadingOverlay = false;
                this.$helper.toastSuccess(this, "Gambar/video berhasil diunggah!");
                this.resetUploadTimestamp();
                this.getItems();
                this.$bvModal.hide("m-image")
            } catch (error) {
                console.error("Upload file adjustment", error)
                this.$helper.toastError(this, "Gagal mengunggah media");
            }  finally {
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
            }
        },
        formatTime(date) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        },
        resetUploadTimestamp() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null,
            };
        },
        sumNetWeight(dryWeight, weightReduction) {
            return (dryWeight - weightReduction).toFixed(2);
        },
        onAdjustmentInput(item) {
            this.sanitize(item);

            if (item.adjustment && item.adjustment !== '') {
                this.$set(item, 'adjustmentPercent', '');
            }

            this.$forceUpdate();
        },
        onAdjustmentPercentInput(item) {
            if (item.adjustmentPercent && item.adjustmentPercent !== '') {
                this.$set(item, 'adjustment', '');
            }

            this.$forceUpdate();
        },
        isAdjustmentDisabled(item) {
            return item.adjustmentPercent != null && item.adjustmentPercent !== '';
        },
        isAdjustmentPercentDisabled(item) {
            return item.adjustment != null && item.adjustment !== '';
        },
        onSelectAdjustment(e) {

            const selected = this.addAdj.selectedCategoryAdjustments.find(
                adj => adj.id === e
            );
            const adjPercentages = selected.adjustment_percentages;

            this.addAdj.is_increment = selected.is_increment;

            if (!adjPercentages) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            const basePrice = this.data.price;

            const adjustmentObj = adjPercentages.find(
                range => basePrice >= range.from && basePrice <= range.to
            );

            const adjustmentPrice = adjustmentObj ? adjustmentObj.nominal : null;

            if (adjustmentPrice == null) {
                this.addAdj.adjustment = "";
                this.addAdj.hasAdjustmentPrice = false;
                return;
            }

            // set default amount adjustment based on range
            let cleaned = String(adjustmentPrice).replace(/\./g, "")
            let res = cleaned.replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")

            this.addAdj.adjustment = res;
            this.addAdj.hasAdjustmentPrice = true;

        }
    },
    computed: {
        filterMediaList() {
            return this.mediaList.filter(item => item.status != 'delete')
        },
        kelengkapan() {
            return this.data.is_batangan ? "Batangan" : "Lengkap";
        },
        isShowSimulationAdjDamage() {
            return this.$helper.checkRoleNumber(EnumPermissions.SIMULASI_ADJUSTMENT_KERUSAKAN.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        itemFlags() {
            return {
                isLMRetro: this.data.kind_id === 261,
                isLMScan: this.data.kind_id === 251,
                isPerhiasan: this.data.kind_id === 257,
            }
        },
        hasMark() {
            return this.data.has_mark ? "Ada" : "Tidak Ada";
        },
        filteredFields() {
            return this.invoiceDetailId == null
                ? this.fields.filter(field => field.key !== 'action')
                : this.fields;
        },
        hasAddAdjInventoryPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.ADD_ADJ_INVENTORY.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasDeleteAdjInventoryPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.DELETE_ADJUSTMENT_INVENTORY.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasAddPhotoAdjPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.ADD_FOTO_ADJ.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasDeletePhotoAdjPermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.DELETE_FOTO_ADJ.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
        hasEditAdjPricePermission() {
            return this.$helper.checkRoleNumber(EnumPermissions.EDIT_ADJUSTMENT_PRICE.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
    },
    created() {
        this.init()
    }
}
</script>

<style scoped>

p {
    margin: 0;
}

/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
